import React from 'react';
import { DealAosStack } from './DealAosStack';

// Section 1 — Products hero (3D stack left, editorial copy right).
export const ProductsHero = () => (
  <section id="top" className="pt-16 pb-20 sm:pt-20 sm:pb-28 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FBFBFB] overflow-hidden">
    <div className="w-full max-w-[1600px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 xl:gap-20 items-center">
      {/* Left: interactive 3D Deal OS stack */}
      <div className="hidden lg:block lg:col-span-6 xl:col-span-5 relative z-10">
        <DealAosStack />
      </div>
      {/* Right: editorial copy */}
      <div className="lg:col-span-6 xl:col-span-7 max-w-2xl lg:pl-4 xl:pl-10">
        <div className="text-xs uppercase tracking-wider mb-6 flex items-center gap-2 font-sans font-medium text-stone-500">
          <span className="font-bold text-stone-950 tracking-[0.16em]">THE PLATFORM</span>
          <span className="text-stone-300">·</span>
          <span className="text-stone-600 font-semibold tracking-wider text-[11px] sm:text-xs">PROPRIETARY FULL-STACK DEAL ARCHITECTURE</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[3.25rem] xl:text-[3.5rem] font-bold tracking-tight text-stone-950 leading-[1.1] mb-8">
          The Frontier Deal OS&#8482;: full-stack deal architecture.
        </h1>

        <div className="space-y-5 text-base sm:text-lg text-stone-700 leading-relaxed font-sans font-normal">
          <p className="text-lg sm:text-xl text-stone-900 font-medium leading-snug">
            The autonomous cognitive engine for the entire deal lifecycle, built on four proprietary layers from the executive cockpit down to domain reasoning SLMs.
          </p>
          <p>
            Every layer is proprietary IP, deployed 100% inside your tenant. Frontier activates your existing cloud, models, and deal playbooks into a single context-locked runtime, from raw dataroom evidence to the board-ready IC verdict.
          </p>
        </div>
      </div>
    </div>
  </section>
);
